const fetchOverviewData = (payload) => ({
    type: 'FETCH_CRM/OVERVIEW/DATA_INIT',
    payload,
  });

  export const fetchOverviewSuccess = (data) => ({
    type: 'FETCH_CRM/OVERVIEW/DATA_SUCCESS',
    payload: data,
  });
  
  export const fetchOverviewFailure = (error) => ({
    type: 'FETCH_CRM/OVERVIEW/DATA_FAIL',
    error: error.message,
  });
  
  export { fetchOverviewData };